export default {
    book: '{product} rezervasyonu yap',
    age_limit: 'Yalnızca {age} Yaş Üstü',
    change_plan: "Plan değiştir",
    upgrade_product: 'Ürünü güncelle',
    upgrade: "Güncelleme",
    cancel_upgrade: "Yükseltmeyi İptal Et",
    choose_product: '{product} seçin',
    days: '{count} gün | {count} gün',
    login_register: "Giriş/Kayıt",
    current: "Akım",
    keyless_benefits: {
        label: 'Doğrudan arabaya {0}',
        highlight: 'kiralama servisi™',
        list: {
            cant_lose_the_key: 'Tam sigorta',
            zero_excess: 'Sıfır Fazlalık',
            phone_as_a_key: 'Anahtar olarak Telefon',
            straight_to_car: 'Beklemek yok',
            no_queues: 'Kuyruk yok',
            online_id_check: 'Çevrimiçi ID Kontrolü',
            self_checkout: 'Kendi Kendine Kontrol',
        },
    },
}
